import { useEffect, useRef, useState } from "react";
import FormDropDown from "../../../forms/DropDownList/FormDropDown";
import "./TriviaStatus.scss";
import ToggleCheck from "../../../forms/ToggleCheck/ToggleCheck";

const TriviaStatus = (props) => {
    const featureVars = props.featureVars;
    const roundsCount = props?.customisationData?.setup?.triviaData?.triviaSetup?.[0]?.roundsCount ?? 1;
    let selectedRound = featureVars.triviaControl?.selectedRound ?? props.passedInPreviewData?.triviaControl?.selectedRound ?? 0;
    if (isNaN(selectedRound) || selectedRound < 0 || selectedRound >= roundsCount || selectedRound == '') {
        selectedRound = 0;
    }

    const triviaData = props.customisationData?.setup?.['triviaData' + (selectedRound + 1)]?.questions;
    const roundSetup = (featureVars.triviaControl?.roundSetup && featureVars.triviaControl?.roundSetup !== '' ? featureVars.triviaControl?.roundSetup : props.passedInPreviewData?.triviaControl?.roundSetup) ?? null;
    const getRoundQuestionIndex = () => {
        if (roundSetup) {
            const currentRound = selectedRound; // featureVars.triviaControl?.selectedRound ?? props.passedInPreviewData?.triviaControl?.selectedRound ?? 0;
            const currentRoundQuestionIndex = featureVars.triviaControl?.currentRoundQuestionIndex ?? props.passedInPreviewData?.triviaControl?.currentRoundQuestionIndex ?? 0;
            if (roundSetup?.[currentRound] && roundSetup?.[currentRound]?.[currentRoundQuestionIndex]) {
                return roundSetup[currentRound][currentRoundQuestionIndex];
            }
        }
        return 0;
    }
    const selectedTriviaIndex = getRoundQuestionIndex(); // featureVars.triviaControl.useRounds ? getRoundQuestionIndex() : featureVars.triviaControl.selectedTrivia;
    const selectedTriviaData = triviaData?.[selectedTriviaIndex];
    // const triviaType = selectedTriviaData?.type;

    console.log('--- TriviaStatus, selectedTriviaData: ', selectedTriviaData, featureVars, props);

    const [forceUpdate, setForceUpdate] = useState(0);
    const forceUpdateNow = () => {
        setForceUpdate((val) => val + 1);
    }

    /* const resetCorrectAnswers = () => {
        const triviaStateData = findTriviaStateData(selectedTriviaData);
        for (let i = 0; i < triviaStateData.answerState.length; i++) {
            triviaStateData.answerState[i].correct = false;
        }
    } */

    const findTriviaStateData = (triviaData_arg) => {
        if (!triviaData_arg) {
            return null;
        }
        let triviaStateData = null;
        console.log('--- TRIVIA_STATE, findTriviaStateData: ', props.previewControls, props.passedInPreviewData, selectedRound, roundsCount);
        if (props.previewControls && props.passedInPreviewData.triviaControl?.triviaState) {
            const triviaTitle = triviaData_arg.title;
            if (typeof props.passedInPreviewData.triviaControl.triviaState?.[selectedRound]?.length === 'number') {
                for (let i = 0; i < props.passedInPreviewData.triviaControl.triviaState?.[selectedRound]?.length; i++) {
                    if (props.passedInPreviewData.triviaControl.triviaState[selectedRound][i].triviaTitle === triviaTitle) {
                        triviaStateData = props.passedInPreviewData.triviaControl.triviaState[selectedRound][i];
                    }
                }
            }
        }
        if (triviaStateData === null && featureVars.triviaControl?.triviaState) {
            const triviaTitle = triviaData_arg.title;
            if (typeof featureVars.triviaControl.triviaState?.[selectedRound]?.length === 'number') {
                for (let i = 0; i < featureVars.triviaControl.triviaState?.[selectedRound]?.length; i++) {
                    if (featureVars.triviaControl.triviaState[selectedRound][i].triviaTitle === triviaTitle) {
                        triviaStateData = featureVars.triviaControl.triviaState[selectedRound][i];
                    }
                }
            }
        }
        if (triviaStateData === null) {
            if (typeof featureVars.triviaControl.triviaState === 'undefined' || featureVars.triviaControl.triviaState === null || !Array.isArray(featureVars.triviaControl.triviaState) || !Array.isArray(featureVars.triviaControl.triviaState?.[0])) {
                featureVars.triviaControl.triviaState = [];
                /* for (let i = 0; i < roundsCount; i++) {
                    featureVars.triviaControl.triviaState.push([]);
                } */
            }
            while (featureVars.triviaControl.triviaState.length < roundsCount) {
                featureVars.triviaControl.triviaState.push([]);
            }
            triviaStateData = {
                triviaTitle: triviaData_arg.title,
                triviaRunning: false,
                answerState: []
            };

            console.log('--- TRIVIA_STATE, Initialising triviaStateData for: ', featureVars, triviaStateData, selectedRound, roundsCount);

            featureVars.triviaControl.triviaState[selectedRound].push(triviaStateData);
        }

        // triviaStateData.type = triviaData.type;

        if (Array.isArray(triviaStateData.answerState) === false) {
            triviaStateData.answerState = [];
        }
        // Make sure we have state data for each answer
        // State data is in the following format:
        // {
        //     included: [boolean],
        //     correct: [boolean],
        //     votePercentage: [integer]
        // }
        // We can report the state back from the trivia to keep the votePercentage up to date, although prob only at the of voting start and end
        for (let i = 0; i < 10; i++) {
            if (triviaData_arg['answer' + (i + 1)] && triviaData_arg['answer' + (i + 1)] !== '') {
                if (typeof triviaStateData.answerState[i] === 'undefined') {
                    triviaStateData.answerState.push({
                        included: true,
                        correct: false,
                        votePercentage: 0
                    });
                }
            } else {
                // A blank / non existent answer means we don't have any more answers
                break;
            }
        }

        return triviaStateData;
    }

    const triviaStateData = findTriviaStateData(selectedTriviaData);
    const passedInPreviewData = props?.passedInPreviewData;
    const changeValFunc = props.changeValFunc;
    const reportCustomisationVarsChanged = props.reportCustomisationVarsChanged;

    useEffect(() => {
        const varsToUse = passedInPreviewData ? passedInPreviewData : featureVars;
        if (varsToUse?.triviaControl?.triviaState?.[selectedRound]) {
            for (let i = 0; i < varsToUse.triviaControl.triviaState[selectedRound].length; i++) {
                const triviaStateData_i = varsToUse.triviaControl.triviaState[selectedRound][i];
                
                /* if (triviaStateData_i && triviaStateData_i.triviaRunning === true) {
                    // Set a flag to show we have not reported our data yet, we only save the data at the end of the trivia
                    // console.log('--- ANSWER_SELECTOR, useEffect (Reset pollRunDataSaved): ', pollStateData_i);
                    pollStateData_i.pollRunDataSaved = false;
                } */

                // if (pollStateData_i && pollStateData_i.pollRunning === false && pollStateData_i.pollHasVotes === true) {
                    // Set triviaStateData.highlightRemovedAnswers to true ready for when we hit send / show the previous trivia data
                    // console.log('--- ANSWER_SELECTOR, useEffect (Time to highlight removed answers): ', triviaStateData_i);
                    // triviaStateData_i.highlightRemovedAnswers = true;

                    /* if (pollStateData_i.pollRunDataSaved === false) {
                        // Save the poll results to customisationData
                        if (pollStateData_i.type !== 'predictive' || pollStateData_i.correctAnswer !== -1) {
                            // console.log('--- ANSWER_SELECTOR, useEffect (Time to save data): ', pollStateData_i, props.customisationData);
                            pollStateData_i.pollRunDataSaved = true;

                            // Save the poll results to customisationData
                            if (!props.isPreview && reportCustomisationVarsChanged) {
                                // No saving of runs in preview mode!
                                const pollsData = props.customisationData?.setup?.pollData?.polls;
                                if (pollsData) {
                                    let completedPollData = null;
                                    for (let i = 0; i < pollsData.length; i++) {
                                        if (pollsData[i].title === pollStateData_i.pollTitle) {
                                            completedPollData = pollsData[i];
                                        }
                                    }
                                    if (completedPollData) {
                                        // console.log('--- ANSWER_SELECTOR, useEffect (Completed poll data): ', completedPollData);
                                        let runData = null;
                                        let addNewRun = true;
                                        for (let j = 0; j < props.customisationData.setup.runData.polls.length; j++) {
                                            if (props.customisationData.setup.runData.polls[j].title === pollStateData_i.pollTitle && props.customisationData.setup.runData.polls[j].timeAndDate === pollStateData_i.startTime) {
                                                runData = props.customisationData.setup.runData.polls[j];
                                                addNewRun = false;
                                            }
                                        }
                                        if (addNewRun) {
                                            let channelString = '';
                                            if (props.channels) {
                                                if (Array.isArray(props.channels)) {
                                                    for (let i = 0; i < props.channels.length; i++) {
                                                        if (channelString !== '') {
                                                            channelString += ', ';
                                                        }
                                                        channelString += props.channels[i].twitchHandle;
                                                    }
                                                }
                                            }
                                            if (channelString === '') {
                                                channelString = 'none';
                                            }
                                            runData = {
                                                title: pollStateData_i.pollTitle,
                                                timeAndDate: pollStateData_i.startTime,
                                                channel: channelString,
                                                type: pollStateData_i.type,
                                                removalType: completedPollData.removalType,
                                                question: completedPollData.question,
                                            };
                                            props.customisationData.setup.runData.polls.push(runData);

                                            // Record our run data!
                                            let totalVotes = 0;
                                            let mostVotedVotes = 0;
                                            let leastVotes = 1000000;
                                            for (let i = 1; i <= 10; i++) {
                                                runData['answer' + i] = completedPollData['answer' + i];
                                                runData['included' + i] = pollStateData_i.answerState?.[i - 1]?.includedInLastVote ?? false;
                                                runData['votes' + i] = pollStateData_i.rawAnswerVoteCounts?.[i - 1] ?? 0;
                                                runData['percentage' + i] = pollStateData_i.answerState?.[i - 1]?.votePercentage ?? 0;
                                                totalVotes += pollStateData_i.rawAnswerVoteCounts?.[i - 1] ?? 0;
                                                if (pollStateData_i.rawAnswerVoteCounts?.[i - 1] > mostVotedVotes) {
                                                    mostVotedVotes = pollStateData_i.rawAnswerVoteCounts?.[i - 1];
                                                }
                                                if (pollStateData_i.rawAnswerVoteCounts?.[i - 1] < leastVotes) {
                                                    leastVotes = pollStateData_i.rawAnswerVoteCounts?.[i - 1];
                                                }
                                                runData['winner' + i] = false;
                                                if (pollStateData_i.type === 'removal') {
                                                    if (pollStateData_i.answerState?.[i - 1]?.includedInLastVote) {
                                                        runData['winner' + i] = !pollStateData_i.answerState?.[i - 1]?.included ?? false;
                                                    } else {
                                                        runData['winner' + i] = false;
                                                    }
                                                } else
                                                if (pollStateData_i.type === 'predictive') {
                                                    runData['winner' + i] = pollStateData_i.answerState?.[i - 1]?.correct ?? false;
                                                }
                                            }
                                            runData.totalVotes = totalVotes;
                                            let mostVotedAnswer = '';
                                            for (let i = 1; i <= 10; i++) {
                                                if (pollStateData_i.rawAnswerVoteCounts?.[i - 1] === mostVotedVotes) {
                                                    if (mostVotedAnswer !== '') {
                                                        mostVotedAnswer += ', ';
                                                    }
                                                    mostVotedAnswer += completedPollData['answer' + i];
                                                    if (pollStateData_i.type === 'opinion') {
                                                        runData['winner' + i] = true;
                                                    }
                                                }
                                            }
                                            runData.winningAnswer = mostVotedAnswer;

                                            let cumulativeRunData = null;
                                            for (let j = 0; j < props.customisationData.setup.totalData.polls.length; j++) {
                                                if (props.customisationData.setup.totalData.polls[j].title === pollStateData_i.pollTitle && props.customisationData.setup.totalData.polls[j].type === pollStateData_i.type) {
                                                    cumulativeRunData = props.customisationData.setup.totalData.polls[j];
                                                }
                                            }
                                            if (!cumulativeRunData) {
                                                cumulativeRunData = {
                                                    title: pollStateData_i.pollTitle,
                                                    type: pollStateData_i.type,
                                                    removalType: completedPollData.removalType,
                                                    question: completedPollData.question,
                                                }
                                                props.customisationData.setup.totalData.polls.push(cumulativeRunData);
                                            }
                                            cumulativeRunData.totalVotes = (cumulativeRunData.totalVotes || 0) + totalVotes;
                                            cumulativeRunData.runCount = (cumulativeRunData.runCount || 0) + 1;
                                            cumulativeRunData.lastRun = runData.timeAndDate;
                                            // copy answers from runData, update total votes
                                            for (let i = 1; i <= 10; i++) {
                                                cumulativeRunData['answer' + i] = runData['answer' + i];
                                                cumulativeRunData['votes' + i] = (cumulativeRunData['votes' + i] || 0) + runData['votes' + i];
                                                cumulativeRunData['percentage' + i] = Math.round((cumulativeRunData['votes' + i] / cumulativeRunData.totalVotes) * 100);
                                            }
                                            // Find most popular answer
                                            let mostPopularAnswer = '';
                                            let mostPopularVotes = 0;
                                            for (let i = 1; i <= 10; i++) {
                                                if (cumulativeRunData['votes' + i] > mostPopularVotes) {
                                                    mostPopularVotes = cumulativeRunData['votes' + i];
                                                }
                                            }
                                            for (let i = 1; i <= 10; i++) {
                                                if (cumulativeRunData['votes' + i] === mostPopularVotes) {
                                                    if (mostPopularAnswer !== '') {
                                                        mostPopularAnswer += ', ';
                                                    }
                                                    mostPopularAnswer += cumulativeRunData['answer' + i];
                                                }
                                            }
                                            cumulativeRunData.winningAnswer = mostPopularAnswer;

                                            // console.log('--- ANSWER_SELECTOR, useEffect (Saving run data): ', runData, cumulativeRunData);

                                            reportCustomisationVarsChanged(props.customisationVars, props.featureId);
                                        }
                                    }
                                }
                            } /* else {
                                console.log('--- ANSWER_SELECTOR, useEffect (no saving run data in preview mode): ', pollStateData_i);
                            } */
                        /* }
                    } */
                // }

                if (triviaStateData.triviaTitle === triviaStateData_i.triviaTitle) {
                    let triviaHasVotes = false;
                    let correctAnswer = -1;
                    for (let i = 0; i < triviaStateData_i.answerState.length; i++) {
                        if (triviaStateData_i.answerState[i].votePercentage > 0) {
                            triviaHasVotes = true;
                        }
                        /* if (triviaStateData_i.answerState[i].correct) {
                            correctAnswer = i;
                        } */
                    }

                    // make sure top level, ie. varsToUse.triviaControl.triviaHasVotes is updated
                    if (typeof triviaStateData.triviaHasVotes !== 'undefined' && triviaStateData.triviaHasVotes !== triviaHasVotes) {
                        // console.log('--- ANSWER_SELECTOR, Set triviaHasVotes to: ', triviaHasVotes);
                        setTimeout(() => changeValFunc('triviaControl', 'triviaHasVotes', triviaHasVotes, false, false, triviaStateData.correctAnswer !== correctAnswer ? false : true), 20);
                    }
                    // make sure top level, ie. varsToUse.triviaControl.correctAnswer is updated
                    /* if (typeof triviaStateData.correctAnswer !== 'undefined' && triviaStateData.correctAnswer !== correctAnswer) {
                        // console.log('--- ANSWER_SELECTOR, Set correctAnswer to: ', correctAnswer);
                        setTimeout(() => changeValFunc('triviaControl', 'correctAnswer', correctAnswer, false, false, true), 20);
                    } */  
                }
            }
        }
    }, [triviaStateData, featureVars, passedInPreviewData, changeValFunc]);

    let winningAnswerIndex = -1;
    let winningAnswerVotePercentage = 0;
    if (triviaStateData) {
        for (let i = 0; i < triviaStateData.answerState.length; i++) {
            if (triviaStateData.answerState[i].votePercentage > winningAnswerVotePercentage) {
                winningAnswerVotePercentage = triviaStateData.answerState[i].votePercentage;
                winningAnswerIndex = i;
            }
        }
    }

    const currentRound = featureVars.triviaControl?.selectedRound ?? props.passedInPreviewData?.triviaControl?.selectedRound ?? 0;
    const currentRoundQuestionIndex = featureVars.triviaControl?.currentRoundQuestionIndex ?? props.passedInPreviewData?.triviaControl?.currentRoundQuestionIndex ?? 0;

    return (
        <div className="fl-column live-trivia-answers-selector">
            {!triviaStateData &&
                <div className="form-field-content label">
                    Trivia Status Not Available
                </div>
            }
            {triviaStateData &&
                <>
                    <div className="form-field-content var-label">
                        Trivia Status
                    </div>
                    <div className="fl-column no-gap">
                        {/*pollType === 'opinion' &&
                            <>
                                <div className="poll-type">Opinion Poll.</div>
                                <div>Results will appear below after the voting ends.</div>
                            </>
                        */}
                        {/*pollType === 'predictive' &&
                            <>
                                <div className="poll-type">Predictive Poll.</div>
                                <div>You will be able to select the correct answer below when voting is not active.</div>
                            </>
                        */}
                        {/*pollType === 'removal' &&
                            <>
                                <div className="poll-type">Removal Poll.</div>
                                <div>You will be able to select the answers to include / remove when voting is not active. Only these answers will be included the next time you run this poll.</div>
                            </>
                        */}
                        <div>Results will appear below after the voting ends.</div>
                        {triviaStateData.triviaRunning &&
                            <div className="trivia-running">Voting is currently active...</div>
                        }
                        {!triviaStateData.triviaRunning &&
                            <div className="trivia-not-running">Voting is not currently active.</div>
                        }
                    </div>
                    {/*featureVars.triviaControl.useRounds &&*/
                        <div>Round <span className="bold-text">{currentRound + 1}</span>, Question <span className="bold-text">{currentRoundQuestionIndex + 1}</span></div>
                    }
                    <div><span className='question-text'>{selectedTriviaData.question}</span></div>
                    {triviaStateData.answerState.map((answer, index) => {
                        /* let toggleEnabled = !triviaStateData.triviaRunning;
                        if (toggleEnabled && pollType === 'predictive') {
                            if (triviaStateData.correctAnswer !== -1 || !triviaStateData.triviaHasVotes) {
                                toggleEnabled = false;
                            }
                        } */
                        return (
                            <div className="fl-row compact" key={index}>
                                {/*(pollType === 'predictive' || pollType === 'removal') &&
                                    <div className="shrink">
                                        <ToggleCheck
                                            label={selectedPollData['answer' + (index + 1)]}
                                            showLabel={false}
                                            currentState={pollType === 'predictive' ? answer.correct : answer.included}
                                            toggleFunc={(e, id) => {
                                                if (pollType === 'predictive') {
                                                    const correct = !answer.correct;
                                                    resetCorrectAnswers();
                                                    answer.correct = correct;
                                                } else {
                                                    answer.included = !answer.included;
                                                }
                                                forceUpdateNow();
                                                // props.setFeatureVars(featureVars);
                                            }}
                                            enabled={toggleEnabled}
                                        />
                                    </div>
                                */}
                                <div className={`grow answer-text ${selectedTriviaData.correctAnswer === 'answer' + (index + 1) ? 'correct-answer' : ''} ${answer.votePercentage > 0 && (index === winningAnswerIndex || answer.votePercentage === winningAnswerVotePercentage) ? 'winning-answer' : ''}`}>
                                    {selectedTriviaData['answer' + (index + 1)]}
                                </div>
                                <div className="shrink vote-percentage">
                                    {answer.votePercentage}%
                                </div>
                            </div>
                        )
                    })}
                </>
            }
        </div>
    )
}

export default TriviaStatus;
